import { render, staticRenderFns } from "./MainHeaderMenuSports.vue?vue&type=template&id=b4cca956&scoped=true"
import script from "./MainHeaderMenuSports.vue?vue&type=script&lang=js"
export * from "./MainHeaderMenuSports.vue?vue&type=script&lang=js"
import style0 from "./MainHeaderMenuSports.vue?vue&type=style&index=0&id=b4cca956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cca956",
  null
  
)

export default component.exports